function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_FALLBACK = '--';
var getFractionOption = function getFractionOption(rawValue, fractionDigits) {
  if (typeof fractionDigits === 'number') {
    return {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    };
  }
  var valueStr = String(rawValue);
  if (valueStr.includes('.')) {
    return {
      minimumFractionDigits: Math.min(2, valueStr.split('.')[1].length),
      maximumFractionDigits: 2
    };
  }
  return {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  };
};
var formatWithSeparator = function formatWithSeparator(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (value === null || value === undefined || value === '') {
    return DEFAULT_FALLBACK;
  }
  var num = Number(value);
  if (Number.isNaN(num)) {
    return "".concat(value);
  }
  var fractionOption = getFractionOption(value, options.fractionDigits);
  return new Intl.NumberFormat('zh-CN', _objectSpread({
    useGrouping: true
  }, fractionOption)).format(num);
};
export var formatToYuan = function formatToYuan(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$showUnit = _ref.showUnit,
    showUnit = _ref$showUnit === void 0 ? true : _ref$showUnit,
    _ref$unit = _ref.unit,
    unit = _ref$unit === void 0 ? '元' : _ref$unit,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? DEFAULT_FALLBACK : _ref$fallback,
    fractionDigits = _ref.fractionDigits;
  var formatted = formatWithSeparator(value, {
    fractionDigits: fractionDigits
  });
  if (formatted === DEFAULT_FALLBACK) {
    return fallback;
  }
  return showUnit ? "".concat(formatted).concat(unit) : formatted;
};
export var formatNumberWithComma = function formatNumberWithComma(value) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$fallback = _ref2.fallback,
    fallback = _ref2$fallback === void 0 ? DEFAULT_FALLBACK : _ref2$fallback,
    fractionDigits = _ref2.fractionDigits;
  var formatted = formatWithSeparator(value, {
    fractionDigits: fractionDigits
  });
  return formatted === DEFAULT_FALLBACK ? fallback : formatted;
};